import React, { useState, useEffect } from "react";
import { Layout, Card, Form, Input, Button, Checkbox } from "antd";
import { toast } from "react-toastify";
import languages from "../../constants/languages";
import { getDetailUser, createUser, updateUser } from "../../services/user";

const defaultForm = { name: "", login: "" };

export const UserForm = (props) => {
  const [id, setId] = useState(null);
  const [fields, setFields] = useState(null);
  const [editPassword, setEditPassword] = useState(false);

  useEffect(() => {
    if (props.match && props.match.params && props.match.params.id) {
      setId(props.match.params.id);
      getDetailUser(props.match.params.id).then((res) => {
        if (res.status == 1) {
          setFields({
            ...res.data,
          });
        } else {
          toast.error(res.message);
        }
      });
    } else {
      setFields(defaultForm);
    }
    // component unmount
    return () => {
      setFields(null);
    };
  }, [props.match.params.id]);

  const onFinish = (values) => {
    if (id) {
      onUpdateUser(values);
    } else {
      onCreateUser(values);
    }
  };
  const onCreateUser = (values) => {
    if (values.password != values.re_password) {
      return toast.error(languages.passwordNotMatch);
    }
    createUser(values).then((res) => {
      if (res.status === 1) {
        toast.success(languages.createUserSuccess);
        props.history.push(`${process.env.PUBLIC_URL}/user/list`);
      } else {
        toast.error(
          <>
            {res.message.map((mes, index) => {
              return <p key={index}>{mes.msg}</p>;
            })}
          </>
        );
      }
    });
  };

  const onUpdateUser = (values) => {
    const params = {
      login: values.login,
      name: values.name,
      note: values.note,
    };
    if (editPassword) {
      params.password = values.password;
      params.re_password = values.re_password;
    }

    if (editPassword && values.password != values.re_password) {
      return toast.error(languages.passwordNotMatch);
    }
    updateUser(id, params).then((res) => {
      if (res.status === 1) {
        toast.success(languages.updateUserSuccess);
        props.history.push(`${process.env.PUBLIC_URL}/user/list`);
      } else {
        toast.error(
          <>
            {res.message.map((mes, index) => {
              return <p key={index}>{mes.msg}</p>;
            })}
          </>
        );
      }
    });
  };

  const onClickCancel = () => {
    props.history.push(`${process.env.PUBLIC_URL}/user/list`);
  };

  const onChangeEditPassword = (e) => {
    setEditPassword(e.target.checked);
  };

  if (!fields) {
    return <div>Loading...</div>;
  }

  return (
    <Layout className="layout-server flex-1">
      <Card title={languages.titleCreateUser} className="flex-1">
        <Form layout={"vertical"} onFinish={onFinish} initialValues={fields}>
          <Form.Item
            name="name"
            label={
              <div>
                {languages.formUserName}
                <span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="login"
            label={
              <div>
                {languages.formUserLogin}
                <span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
          >
            <Input />
          </Form.Item>
          <Form.Item name="note" label={"メモ"} wrapperCol={{ span: 7 }}>
            <Input />
          </Form.Item>
          {id && (
            <Form.Item name="change_password">
              <Checkbox onChange={onChangeEditPassword}>
                {languages.updatePassword}
              </Checkbox>
            </Form.Item>
          )}
          {(!id || editPassword) && (
            <>
              <Form.Item
                name="password"
                label={
                  <div>
                    {languages.formUserPassword}
                    <span className="required-field">(必須)</span>
                  </div>
                }
                wrapperCol={{ span: 7 }}
              >
                <Input type="password" />
              </Form.Item>
              <Form.Item
                name="re_password"
                label={
                  <div>
                    {languages.formUserRePassword}
                    <span className="required-field">(必須)</span>
                  </div>
                }
                wrapperCol={{ span: 7 }}
              >
                <Input type="password" />
              </Form.Item>
            </>
          )}
          <Button type="primary" className="mr10 btn-success" htmlType="submit">
            保存
          </Button>
          <Button onClick={onClickCancel}>キャンセル</Button>
        </Form>
      </Card>
    </Layout>
  );
};
